import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeEaState } from '@store/actions/eaAction';
import PersonalCheckPopup from '@components/ea/PersonalCheckPopup';
import { showAlert } from '@store/actions/commonAction';

const PersonalCheckMain = props => {
  const {
    planMainInfo,
    contractSign,
    contract,
    onClickPrev,
    searchPasteSignData,
    signPasteData,
    complete,
    searchSignData,
    signData,
    onSave,
    isPracticeMode,
    practiceSignName,
    practiceSignature,
    isForiegner, // 외국인 여부
  } = props;

  const dispatch = useDispatch();

  const [isFollowTxtError, setIsFollowTxtError] = useState(false);
  const [pasteCheck, setPasteCheck] = useState(false); // 붙여넣기 체크 여부
  const [signNameData, setSignNameData] = useState(''); // 성명
  const [signatureData, setSignatureData] = useState(''); // 서명
  const [isValid, setIsValid] = useState(false);

  // 리듀서값 변경
  const handleInputChange = (target, value) => {
    const changeData = contractSign.map(data => {
      if (data.step === 526) {
        if (target.includes('q1')) {
          const regex = /(^[A-Za-z\s+]*$)/;
          if (value === '' || regex.test(value)) {
            return { ...data, q1: value };
          } else {
            dispatch(showAlert({ message: '영문으로 입력해 주세요.' }));
            return { ...data };
          }
        } else if (target.includes('q2')) {
          return { ...data, q2: value };
        } else if (target.includes('q3')) {
          if (target.includes('_0')) {
            return { ...data, q3: [value, data.q3[1]] };
          } else if (target.includes('_1')) {
            return { ...data, q3: [data.q3[0], value] };
          } else {
            return { ...data, q3: [value, ''] };
          }
        } else if (target.includes('q4')) {
          const regex = /(^[A-Za-z0-9+]*$)/;
          if (value === '' || regex.test(value)) {
            if (target.includes('_0')) {
              return {
                ...data,
                q4: [value, data.q4[1]],
                q5: ['', data.q5[1]],
                // q6: ['', data.q6[1]],
              };
            } else {
              return {
                ...data,
                q4: [data.q4[0], value],
                q5: [data.q5[0], ''],
                // q6: [data.q6[0], ''],
              };
            }
          } else {
            isValidCheck();
            return { ...data };
          }
        } else if (target.includes('q5')) {
          if (target.includes('_0')) {
            return {
              ...data,
              q4: ['', data.q4[1]],
              q5: [value, data.q5[1]],
              // q6: ['', data.q6[1]],
            };
          } else {
            return {
              ...data,
              q4: [data.q4[0], ''],
              q5: [data.q5[0], value],
              // q6: [data.q6[0], ''],
            };
          }
        } else if (target.includes('q6')) {
          if (target.includes('_0')) {
            return {
              ...data,
              q6: [value, data.q6[1]],
            };
          } else {
            return {
              ...data,
              q6: [data.q6[0], value],
            };
          }
        } else {
          return data;
        }
      } else {
        return data;
      }
    });
    dispatch(changeEaState({ type: 'contractSign', data: changeData }));
  };
  // 붙여넣기 서명 조회
  const handlePasteCheck = value => {
    if (value && !isPracticeMode) {
      searchPasteSignData();
    }
    setPasteCheck(value);
  };

  // 확인버튼 valid 체크
  const isValidCheck = () => {
    const personalData = contractSign.filter(data => data.step === 526)[0];
    // 영문이름 체크
    if (personalData.q1.trim() === '') return setIsFollowTxtError(true);

    if (!isForiegner) {
      if (personalData.q3[0] === '') return setIsFollowTxtError(true);

      if (personalData.q5[0] === '') {
        if (personalData.q4[0] === '') return setIsFollowTxtError(true);
      }

      // 납세자번호 length check
      if (contract.etc.taxDutyYn === '2') {
        if (personalData.q4[0].length !== 9) return setIsFollowTxtError(true);
      }
    }

    if (signNameData === '' || signatureData === '')
      return setIsFollowTxtError(true);

    setIsFollowTxtError(false);

    onSave({
      signNameData: signNameData,
      signatureData: signatureData,
      reportId: 'app_form_etc_29',
      signId: 'app_form_etc_29_signid_02',
      nameId: 'app_form_etc_29_signid_01',
    });
  };

  // 완료된 페이지의 경우 기존 저장된 서명데이터 조회
  useEffect(() => {
    if (
      complete &&
      !isPracticeMode &&
      (!signData.app_form_etc_29_signid_01 ||
        !signData.app_form_etc_29_signid_02)
    ) {
      searchSignData(
        'app_form_etc_29',
        `app_form_etc_29_signid_02`,
        `app_form_etc_29_signid_01`,
      );
    }
  }, [complete]);

  // 미국 선택시 자동으로 리듀서 값 변경
  useEffect(() => {
    if (contract.etc.taxDutyYn === '2' && !complete) {
      const changeData = contractSign.map(data => {
        return data.step === 526
          ? {
              ...data,
              q2: planMainInfo.ownerPrspInfo.birthDate,
              q3: ['미국', ''],
            }
          : data;
      });
      dispatch(changeEaState({ type: 'contractSign', data: changeData }));
    }
  }, [contract.etc.taxDutyYn, complete]);

  // 버튼 validation 상태 변경
  useEffect(() => {
    const personalData = contractSign.filter(data => data.step === 526)[0];
    // 영문이름 체크
    if (personalData.q1.trim() === '') return setIsValid(false);

    if (!isForiegner) {
      if (personalData.q3[0] === '') return setIsValid(false);

      if (personalData.q5[0] === '') {
        if (personalData.q4[0] === '') return setIsValid(false);
      }

      // 납세자번호 length check
      if (contract.etc.taxDutyYn === '2') {
        if (personalData.q4[0].length !== 9) return setIsValid(false);
      }
    }
    if (signNameData === '' || signatureData === '') return setIsValid(false);
    return setIsValid(true);
  }, [contractSign, signNameData, signatureData]);

  return (
    <PersonalCheckPopup
      onClickPrev={onClickPrev}
      name={planMainInfo.ownerPrspInfo.name}
      personalData={contractSign.filter(data => data.step === 526)[0]}
      onChange={handleInputChange}
      isFollowTxtError={isFollowTxtError}
      birthDate={planMainInfo.ownerPrspInfo.birthDate}
      etc={contract.etc}
      pasteCheck={pasteCheck}
      onClickPasteCheck={handlePasteCheck}
      signPasteData={signPasteData}
      setSignNameData={setSignNameData}
      setSignatureData={setSignatureData}
      setPasteCheck={setPasteCheck}
      signData={signData}
      complete={complete}
      isValidCheck={isValidCheck}
      isValid={isValid}
      signNameData={signNameData}
      signatureData={signatureData}
      isPracticeMode={isPracticeMode}
      practiceSignName={practiceSignName}
      practiceSignature={practiceSignature}
    />
  );
};

export default PersonalCheckMain;
